<template>
     <div class="consultant">
        <!-- <TheNavigationPanel/> -->
        <v-container>
            <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
            <v-toolbar flat color="#F0FFEA" height="30" >
                <v-toolbar-title style="color:#62AE32" class="headline">Consultants</v-toolbar-title>
             </v-toolbar>
            <v-toolbar flat color="#F0FFEA">
            <v-spacer></v-spacer>
                <v-btn color="#08911b" class="white--text btn-style" router-link to="/consultants/registerconsultant">
                    <v-icon left>mdi-plus</v-icon>
                    Add New Consultant
                </v-btn>
            </v-toolbar>
        <v-card class="my-5">
            <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                color="#08911B"
                hide-details
            ></v-text-field>
            </v-card-title>
             <v-dialog persistent v-model="dialog" max-width="400px">
                    <v-card>
                        <v-card-title>
                        <span class=" black--text">Delete Consultant</span>
                        </v-card-title>

                        <v-card-text>
                        <v-container>
                            <v-card-text class="black--text">Are you sure you want to delete {{user}}?</v-card-text>
                        </v-container>
                        </v-card-text>

                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#62AE32" text @click="dialog=false">No</v-btn>
                        <v-btn color="#62AE32" text @click="deleteConsult(user)">Yes</v-btn>
                        
                        </v-card-actions>
                    </v-card>
                </v-dialog>
              <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="Consultants"
                    :items-per-page="10"
                    :single-select="singleSelect"
                    item-key="name"
                    :search="search"
                    class="px-5"
                    no-data-text="No Registered Consultant In System"
                >
               
                <template v-slot:item.action="{ item }">  
                    <v-card-text class="text-center">
                        <v-btn icon @click="dialog=true">
                        <v-icon
                            style="color:#FF5F58; cursor: pointer;"
                            
                            @mouseover="getUser(item.consultant_id)"
                            
                        >
                            mdi-delete
                        </v-icon>
                        </v-btn>
                    </v-card-text>
                </template>
                  <template v-slot:item.actionDel="{ item }">

                    <v-icon
                      
                      class="mr-2 icon-color"
                      @click="getConsultant(item.id)"
                    >
                      mdi-chevron-right
                    </v-icon>
                  </template>
                 </v-data-table>
            </v-card>
        </div>
         </v-container>
     </div>
</template>



<script>
// import TheNavigationPanel from '../components/TheNavigationPanel'
export default {
    components: {
        // TheNavigationPanel
    },
    data(){
        return{
            dialog:false,
            user:'',
             search: '',
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: true,
                    value: 'name',
                },
                { text: 'Email', value: 'email', sortable:false },
                { text: 'Phone No', value: 'phone_number', sortable:false },
                { text: '', value: 'action', sortable: false },
                { text: '', value: 'actionDel', sortable: false },
            ],
           
        }
    },
    methods:{
        getUser(id){
            this.user = id            
        },
        getConsultant(id){
            
        this.$store.dispatch("ConsultantById", id)
            .then((success)=>{
                this.$router.push(`/consultants/viewConsultant/${success.consultant[0].firstname}`);
            })
            .catch(()=>{
            })
        },
        deleteConsult(id){
            this.$store.dispatch("deleteConsultant",id)
            .then(()=>{
                this.dialog = false
                this.user=''
                this.$store.dispatch("getConsultants")
            })
            .catch(()=>{
                this.dialog = false
            })
        },
       
    },
    computed:{
    Consultants(){
        return this.$store.state.consultants.consultant
    },
    },
    created(){
    this.$store.dispatch("getConsultants")
      .then(()=>{
      })
      .catch(()=>{
      });
    }
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.consultant{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
.icon-color{
   color: #B45C5C;
}
.delete-color{
    color: #ff5f58;
}
.btn-style{
    border-radius: 30px;
    text-transform: initial;
}
</style>